import { render, staticRenderFns } from "./gameMod.vue?vue&type=template&id=657c1fcb&"
import script from "./gameMod.vue?vue&type=script&lang=js&"
export * from "./gameMod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports